import { ref, computed, reactive, watch, nextTick } from "vue";
import { g as getUid } from "./assets/index-Df_FM1j-.js";
import { u as useI18n } from "./assets/index-CgZzOVq6.js";
import "vue-demi";
import { u as useListNavigation } from "./assets/index-BLMLj0sV.js";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import { u as useInputProps } from "./assets/SingleMessage-Dv2wNb7f.js";
import { u as useItemsCustomKeysProps } from "./assets/SingleInput-CdYfqMCu.js";
import { u as usePlacementProp, X as XDropdown } from "./assets/XDropdown-Bc_0Fycm.js";
import { u as useValidationsProp } from "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { u as useVModel } from "./assets/index-BJV0_gaH.js";
import XCard from "./XCard.js";
import XListItem from "./XListItem.js";
import XBadge from "./XBadge.js";
import XFormField from "./XFormField.js";
import { S as SelectActivator, c as createCommomProps } from "./assets/SelectActivator-BRoB6u5T.js";
import ListItemsContainer from "./ListItemsContainer.js";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "./assets/XIcon-U9bwokTN.js";
import "@fortawesome/vue-fontawesome";
import "./assets/index-Ca8wHgNc.js";
import "./assets/index-DKxr0Yto.js";
import "./assets/index-4vIud5LZ.js";
import "@floating-ui/dom";
import "./assets/BaseLink-KuovKwoP.js";
import "./assets/index-hC42R8vZ.js";
import "./assets/index-BWUsUM8p.js";
import "./XCheckbox.js";
import "./BaseOption.js";
import "./MultipleInputs.js";
import "./XLink.js";
import "./XTooltip.js";
import "./BasicContent.js";
import "./ContentBox.js";
import "./CloseButton.js";
import "./AdvancedContent.js";
import "./MessagesContainer.js";
import "./XEllipsis.js";
import "./SearchInput.js";
function useSearch(options) {
  const { props, emit, computedItems } = options;
  const searchTerm = ref("");
  function setSearchTerm(searchValue) {
    searchTerm.value = searchValue;
    emit("input:search", searchValue);
  }
  function cleanSearch() {
    if (props.searchable) setSearchTerm("");
  }
  const isSearchTermNotFound = computed(
    () => computedItems.value.filter((item) => item.value === searchTerm.value).length === 0
  );
  const searchRegExp = computed(() => searchTerm.value && new RegExp(searchTerm.value, "ig"));
  const isSearchMatching = (item) => searchRegExp.value.test(item.text);
  const highlightSearchTerm = (item) => {
    const newElem = { ...item };
    newElem.highlighted = newElem.text.replaceAll(searchRegExp.value, "<b>$&</b>");
    return newElem;
  };
  const filteredItems = computed(() => {
    return searchTerm.value && computedItems.value.reduce((accumulator, item) => {
      if (item.header || !isSearchMatching(item) || !item.text) return accumulator;
      return [...accumulator, highlightSearchTerm(item)];
    }, []);
  });
  const canShowEmptySearchMessage = computed(
    () => searchTerm.value && filteredItems.value.length === 0 && !props.createNewItemLabel
  );
  return {
    searchTerm,
    filteredItems,
    isSearchTermNotFound,
    canShowEmptySearchMessage,
    setSearchTerm,
    cleanSearch
  };
}
const { setupVModel } = useVModel();
const { DEFAULT_OPTIONS, createItemObject, itemHasCorrectKeys } = useItemsCustomKeysProps();
function useItems(options) {
  const { props, emit, filteredItems, searchTerm, computedItems } = options;
  function selectedItemsControl() {
    const { data: modelValue } = setupVModel(props, emit);
    const shouldReturnObject = computed(() => props.returnObject || props.async);
    function getNewItemValue(option) {
      let optionObject = option;
      if (!itemHasCorrectKeys(option, props)) {
        optionObject = createItemObject(option, props);
      }
      if (shouldReturnObject.value) {
        return optionObject;
      }
      return optionObject.value;
    }
    function getItemFromModelValue(vModelItem) {
      let vModelItemObject = vModelItem;
      if (itemHasCorrectKeys(vModelItem, props)) {
        vModelItemObject = vModelItem.value;
      }
      const validItemObject = computedItems.value.find(
        (item) => String(item.value) === String(vModelItemObject)
      );
      if (validItemObject) {
        return validItemObject;
      }
      return createItemObject(vModelItem, props);
    }
    function getItemsFromModelValue() {
      var _a;
      return props.multiple ? (_a = modelValue.value) == null ? void 0 : _a.map(getItemFromModelValue) : getItemFromModelValue(modelValue.value);
    }
    function setModelValue(newValue) {
      modelValue.value = props.multiple ? newValue.map(getNewItemValue) : getNewItemValue(newValue);
    }
    const selectedItems2 = computed({
      get: () => getItemsFromModelValue(),
      set: (newValue) => setModelValue(newValue)
    });
    function isItemAlreadySelected2(item) {
      if (props.multiple) {
        if (item == null ? void 0 : item.selectAll) return item.value;
        return selectedItems2.value.some((selectedValue) => selectedValue.value === item.value);
      }
      return selectedItems2.value === item.value;
    }
    const isSearchTermNotSelected2 = computed(() => {
      const selectedItemsArray = props.multiple ? selectedItems2.value : [selectedItems2.value];
      return selectedItemsArray.filter((item) => item.value === searchTerm.value).length === 0;
    });
    return {
      selectedItems: selectedItems2,
      isSearchTermNotSelected: isSearchTermNotSelected2,
      isItemAlreadySelected: isItemAlreadySelected2
    };
  }
  const { selectedItems, isSearchTermNotSelected, isItemAlreadySelected } = selectedItemsControl();
  function itemsControl() {
    function getRemovedItem(removedItem) {
      return selectedItems.value.filter((item) => item.value === removedItem.value);
    }
    function emitRemovedItem(removedItem) {
      emit("remove-item", getRemovedItem(removedItem));
    }
    function removeSelectedItem2(removedItem) {
      emitRemovedItem(removedItem);
      selectedItems.value = selectedItems.value.filter((item) => item.value !== removedItem.value);
    }
    function setMultipleSelected(item) {
      if (Array.isArray(item)) {
        selectedItems.value = item;
      } else if (isItemAlreadySelected(item)) {
        removeSelectedItem2(item);
      } else {
        selectedItems.value = [...selectedItems.value, item];
      }
    }
    function setSingleSelected(item) {
      selectedItems.value = item;
    }
    function setSelectedItem2(item) {
      if (props.multiple) setMultipleSelected(item);
      else setSingleSelected(item);
    }
    const canCreateNewItem = computed(
      () => props.searchable && !!props.createNewItemLabel && searchTerm.value
    );
    function createNewItem2() {
      if (canCreateNewItem.value) {
        setSelectedItem2(createItemObject(searchTerm.value, props));
        emit("new-item-created", searchTerm.value);
      }
    }
    return {
      setSelectedItem: setSelectedItem2,
      removeSelectedItem: removeSelectedItem2,
      createNewItem: createNewItem2
    };
  }
  const { setSelectedItem, removeSelectedItem, createNewItem } = itemsControl();
  function useSelectAll() {
    function findSelectedButDisabledItem(item) {
      var _a;
      if (((_a = selectedItems.value) == null ? void 0 : _a.length) && (item == null ? void 0 : item.value)) {
        return !!selectedItems.value.find(
          (selectedItem) => (selectedItem == null ? void 0 : selectedItem.disabled) && selectedItem.value === item.value
        );
      }
      return false;
    }
    const selectedButDisabledItems = computed(() => {
      return computedItems.value.filter((item) => findSelectedButDisabledItem(item));
    });
    const enabledItems = computed(() => {
      return computedItems.value.filter(
        (item) => (item == null ? void 0 : item.value) && !(item == null ? void 0 : item.disabled) || findSelectedButDisabledItem(item)
      );
    });
    const selectAllOptionValue = computed(
      () => selectedItems.value.length === enabledItems.value.length
    );
    const selectAllOption2 = reactive({
      ...createItemObject(
        {
          [DEFAULT_OPTIONS.itemTextKey]: props.selectAllText,
          [DEFAULT_OPTIONS.itemValueKey]: selectAllOptionValue.value
        },
        props
      ),
      selectAll: true,
      dataTestid: "selectAll"
    });
    const canSelectAll2 = computed(() => props.multiple && props.selectAll);
    function handleSelectAllItems2() {
      if (selectAllOption2.value) {
        setSelectedItem(selectedButDisabledItems.value);
      } else {
        setSelectedItem(enabledItems.value);
      }
      selectAllOption2.value = !selectAllOption2.value;
    }
    function isSelectAllOption2(item) {
      return !!(item == null ? void 0 : item.selectAll);
    }
    watch(
      () => selectedItems.value,
      (value) => {
        if (value == null ? void 0 : value.length) {
          selectAllOption2.value = value.length === enabledItems.value.length;
        }
      }
    );
    return {
      selectAllOption: selectAllOption2,
      canSelectAll: canSelectAll2,
      handleSelectAllItems: handleSelectAllItems2,
      isSelectAllOption: isSelectAllOption2
    };
  }
  const { selectAllOption, canSelectAll, handleSelectAllItems, isSelectAllOption } = useSelectAll();
  const itemsList = computed(() => {
    if (canSelectAll.value && !searchTerm.value) {
      return [selectAllOption, ...computedItems.value];
    }
    if (searchTerm.value) {
      return filteredItems.value;
    }
    return computedItems.value;
  });
  return {
    itemsList,
    selectedItems,
    isSearchTermNotSelected,
    isItemAlreadySelected,
    setSelectedItem,
    removeSelectedItem,
    createNewItem,
    isSelectAllOption,
    handleSelectAllItems
  };
}
const XSelect$1 = "_XSelect_1lbyc_1";
const container = "_container_1lbyc_4";
const dropdownMenu = "_dropdownMenu_1lbyc_10";
const menuList = "_menuList_1lbyc_18";
const listItem = "_listItem_1lbyc_24";
const listItemText = "_listItemText_1lbyc_27";
const emptySearchResultsMessage = "_emptySearchResultsMessage_1lbyc_31";
const style0 = {
  XSelect: XSelect$1,
  container,
  dropdownMenu,
  menuList,
  listItem,
  listItemText,
  emptySearchResultsMessage
};
const { createLabelProps, createRequiredProp } = useInputProps();
const { setupTestId } = useDataTestIdProp();
const { createValidationsProp } = useValidationsProp();
const { createVModelProp } = useVModel();
const { createItemsCustomKeysProps, getItemsWithDefaultKeys } = useItemsCustomKeysProps({
  validator: (item) => !(item == null ? void 0 : item.header)
});
const { createPlacementProp } = usePlacementProp();
const { placement } = createPlacementProp("bottom-start");
const { t } = useI18n();
const __default__ = {
  name: "XSelect",
  components: {
    XFormField,
    XDropdown,
    SelectActivator,
    XCard,
    XListItem,
    XBadge,
    ListItemsContainer
  }
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Object, Number, Boolean, Array],
      default: ""
    },
    virtualizedList: {
      type: Boolean,
      default: false
    },
    customError: {
      type: String,
      default: ""
    },
    innerDropdown: {
      type: Boolean,
      default: false
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    maxItems: {
      type: Number,
      default: 6
    },
    betaBadgeText: {
      type: String,
      default: () => t("ds.global.badge.beta")
    },
    newBadgeText: {
      type: String,
      default: () => t("ds.global.badge.new")
    },
    async: {
      type: Boolean,
      default: false
    },
    selectAll: {
      type: Boolean,
      default: false
    },
    selectAllText: {
      type: String,
      default: () => t("ds.xSelect.actions.select.all")
    },
    menuPosition: placement,
    ...createRequiredProp(),
    ...createLabelProps(),
    ...createValidationsProp(),
    ...createVModelProp([String, Object, Number, Boolean, Array]),
    ...createCommomProps(),
    ...createItemsCustomKeysProps()
  },
  emits: [
    "focus",
    "blur",
    "update:modelValue",
    "input:search",
    "new-item-created",
    "remove-item",
    "input"
  ],
  setup(__props, { emit }) {
    const props = __props;
    const { formatTestId } = setupTestId(props);
    const { formatTestId: formatMenuItemTestId } = setupTestId({
      dataTestid: "selectField"
    });
    const uuid = getUid("select-");
    const activatorRef = ref(null);
    const itemsListRef = ref([]);
    const { computedItems } = getItemsWithDefaultKeys(props);
    const {
      searchTerm,
      filteredItems,
      isSearchTermNotFound,
      canShowEmptySearchMessage,
      setSearchTerm,
      cleanSearch
    } = useSearch({ props, emit, computedItems });
    function useMenu() {
      const menuRef2 = ref(null);
      const menuListRef2 = ref(null);
      const isMenuOpened2 = ref(false);
      const menuWidth = ref(0);
      function setMenuVisibility2(visibility = true) {
        isMenuOpened2.value = visibility;
      }
      function setMenuWidth2(newWidth) {
        menuWidth.value = newWidth;
      }
      const menuStyles2 = computed(() => ({
        maxHeight: `calc(var(--space-large-x) * ${props.maxItems})`,
        width: `${menuWidth.value}px`
      }));
      return {
        menuRef: menuRef2,
        menuListRef: menuListRef2,
        isMenuOpened: isMenuOpened2,
        menuStyles: menuStyles2,
        setMenuVisibility: setMenuVisibility2,
        setMenuWidth: setMenuWidth2
      };
    }
    const { menuRef, menuListRef, isMenuOpened, menuStyles, setMenuVisibility, setMenuWidth } = useMenu();
    const {
      itemsList,
      selectedItems,
      isSearchTermNotSelected,
      isItemAlreadySelected,
      setSelectedItem,
      removeSelectedItem,
      createNewItem,
      isSelectAllOption,
      handleSelectAllItems
    } = useItems({
      props,
      emit,
      filteredItems,
      searchTerm,
      computedItems
    });
    const { handleNavigationKeyboard, setInitialFocusByNodeIndex, resetKeyboardNavigation } = useListNavigation({
      itemsListRef,
      virtualizedList: props.virtualizedList,
      horizontal: false
    });
    const hasError = ref(false);
    function handleError(event) {
      hasError.value = event;
    }
    function getMenuItemTestId(item) {
      const testIdKey = (item == null ? void 0 : item.dataTestid) || `${(item == null ? void 0 : item.value) || (item == null ? void 0 : item.header) || item}`;
      return formatMenuItemTestId(`${testIdKey}-Option`);
    }
    const canShowCreateNewItemLabel = computed(
      () => props.createNewItemLabel && props.searchable && searchTerm.value && isSearchTermNotSelected.value && isSearchTermNotFound.value
    );
    const activatorProps = computed(() => ({
      disabled: props.disabled,
      hasError: hasError.value,
      isMenuOpened: isMenuOpened.value,
      dataTestid: props.dataTestid,
      multiple: props.multiple,
      selectedItems: selectedItems.value,
      placeholder: props.placeholder,
      abbreviationSize: props.abbreviationSize,
      searchable: props.searchable,
      searchPlaceholder: props.searchPlaceholder,
      searchTerm: searchTerm.value,
      maxChipTextSize: props.maxChipTextSize,
      maxVisibleSelectedItems: props.maxVisibleSelectedItems,
      createNewItemLabel: props.createNewItemLabel
    }));
    function focusFirstItemOnOpen() {
      if (!props.searchable && isMenuOpened.value) {
        setInitialFocusByNodeIndex();
      }
    }
    function handleSelectItem(item) {
      if (isSelectAllOption(item)) {
        handleSelectAllItems();
      } else {
        setSelectedItem(item);
      }
      cleanSearch();
    }
    function isKeyboardCloseEvent(event) {
      return (event == null ? void 0 : event.key) === "Tab" || (event == null ? void 0 : event.key) === "Enter" || !props.multiple && (event == null ? void 0 : event.code) === "Space";
    }
    function setActivatorFocus() {
      var _a;
      if ((_a = activatorRef.value) == null ? void 0 : _a.$el) activatorRef.value.$el.focus();
    }
    function closeMenu(event) {
      createNewItem();
      cleanSearch();
      setMenuVisibility(false);
      setActivatorFocus();
      if (!isKeyboardCloseEvent(event)) {
        emit("blur");
      }
      resetKeyboardNavigation();
    }
    function openMenu() {
      setMenuVisibility();
      emit("focus");
      nextTick(() => {
        setMenuWidth(activatorRef.value.$el.offsetWidth);
      });
      focusFirstItemOnOpen();
    }
    function handleItemKeyboard(item, event) {
      event.preventDefault();
      if ((event == null ? void 0 : event.key) === "Enter" || (event == null ? void 0 : event.code) === "Space") handleSelectItem(item);
      if (isKeyboardCloseEvent(event)) {
        closeMenu(event);
      }
      handleNavigationKeyboard(event);
    }
    function checkIfIsValidOption(item) {
      return !item.header && !item.disabled;
    }
    function getItemKey(index, item) {
      if (item == null ? void 0 : item.header) {
        return `${index}_${item.header}`;
      }
      return `${index}_${item.value}`;
    }
    return { __sfc: true, createLabelProps, createRequiredProp, setupTestId, createValidationsProp, createVModelProp, createItemsCustomKeysProps, getItemsWithDefaultKeys, createPlacementProp, placement, t, props, emit, formatTestId, formatMenuItemTestId, uuid, activatorRef, itemsListRef, computedItems, searchTerm, filteredItems, isSearchTermNotFound, canShowEmptySearchMessage, setSearchTerm, cleanSearch, useMenu, menuRef, menuListRef, isMenuOpened, menuStyles, setMenuVisibility, setMenuWidth, itemsList, selectedItems, isSearchTermNotSelected, isItemAlreadySelected, setSelectedItem, removeSelectedItem, createNewItem, isSelectAllOption, handleSelectAllItems, handleNavigationKeyboard, setInitialFocusByNodeIndex, resetKeyboardNavigation, hasError, handleError, getMenuItemTestId, canShowCreateNewItemLabel, activatorProps, focusFirstItemOnOpen, handleSelectItem, isKeyboardCloseEvent, setActivatorFocus, closeMenu, openMenu, handleItemKeyboard, checkIfIsValidOption, getItemKey, XCard, XListItem, XBadge, XFormField, XDropdown, SelectActivator, ListItemsContainer };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.XFormField, { class: _vm.$style.XSelect, attrs: { "message": _vm.customError, "help-tooltip": _vm.helpTooltip, "label": _vm.label, "required": _vm.required, "validations": _vm.validations, "full-width": _vm.fullWidth }, on: { "error": _setup.handleError }, scopedSlots: _vm._u([{ key: "default", fn: function({ labelId }) {
    return [_c(_setup.XDropdown, { class: _vm.$style.container, attrs: { "is-open": _setup.isMenuOpened, "full-width": _vm.fullWidth, "disabled": _vm.disabled, "close-on-click-content": !_vm.multiple, "placement": _vm.menuPosition, "inner-dropdown": _vm.innerDropdown, "data-testid": _setup.formatTestId("menu"), "allow-shortcut": "", "disable-trasition": "" }, on: { "focus": _setup.openMenu, "blur": _setup.closeMenu }, scopedSlots: _vm._u([{ key: "activator", fn: function({ on }) {
      return [_c(_setup.SelectActivator, _vm._b({ ref: "activatorRef", attrs: { "label-id": labelId, "uuid": _setup.uuid }, on: { "input:search": _setup.setSearchTerm, "control": on, "arrow-down": function($event) {
        return _setup.setInitialFocusByNodeIndex();
      }, "remove-item": _setup.removeSelectedItem } }, "SelectActivator", _setup.activatorProps, false))];
    } }, { key: "default", fn: function() {
      return [_c(_setup.XCard, { ref: "menuRef", class: _vm.$style.dropdownMenu, style: _setup.menuStyles, attrs: { "padding": "0px", "border-radius": "var(--border-radius-small)", "elevation": "high" } }, [_c("span", { directives: [{ name: "show", rawName: "v-show", value: _setup.canShowEmptySearchMessage, expression: "canShowEmptySearchMessage" }], class: _vm.$style.emptySearchResultsMessage, attrs: { "role": "alert", "aria-live": "polite", "data-testid": _setup.formatTestId("emptySearchMessage") } }, [_vm._v(" " + _vm._s(_setup.t("ds.xSelect.searchEmpty")) + " ")]), _c(_setup.ListItemsContainer, { directives: [{ name: "show", rawName: "v-show", value: !_setup.canShowEmptySearchMessage, expression: "!canShowEmptySearchMessage" }], ref: "menuListRef", class: _vm.$style.menuList, attrs: { "id": _setup.uuid, "role": "listbox", "aria-multiselectable": _vm.multiple, "data-testid": _setup.formatTestId("menuList"), "items": _setup.itemsList, "virtualized-list": _vm.virtualizedList }, on: { "mounted:virtualized-list": _setup.focusFirstItemOnOpen }, scopedSlots: _vm._u([{ key: "before", fn: function() {
        return [_setup.canShowCreateNewItemLabel ? _c(_setup.XListItem, { attrs: { "tag": "li", "data-testid": _setup.getMenuItemTestId(_setup.searchTerm) }, on: { "click": function($event) {
          _setup.createNewItem();
          _setup.cleanSearch();
        } } }, [_vm._v(" " + _vm._s(_vm.createNewItemLabel) + ' "' + _vm._s(_setup.searchTerm) + '" ')]) : _vm._e()];
      }, proxy: true }, { key: "default", fn: function({ list }) {
        return _vm._l(list, function(item, index) {
          return _c(_setup.XListItem, { key: _setup.getItemKey(index, item), ref: "itemsListRef", refInFor: true, class: _vm.$style.listItem, attrs: { "tag": "li", "role": _setup.checkIfIsValidOption(item) && "option", "aria-readOnly": !_setup.checkIfIsValidOption(item), "data-index": item.index || index, "aria-selected": _setup.isItemAlreadySelected(item), "data-testid": _setup.getMenuItemTestId(item), "disabled": item.disabled, "active": _setup.isItemAlreadySelected(item), "checkbox": _vm.multiple && !item.header, "separator": !!item.header, "no-clickable": item.noClickable, "icon-style": item.iconStyle, "icon": item.icon, "ellipsis": "" }, on: { "click": function($event) {
            return _setup.handleSelectItem(item);
          }, "keydown": function($event) {
            return _setup.handleItemKeyboard(item, $event);
          } }, scopedSlots: _vm._u([{ key: "badge", fn: function({ badgeClass }) {
            return [item.isBeta ? _c(_setup.XBadge, { class: badgeClass, attrs: { "icon": "gem", "color": "brand-primary", "size": "sm" } }, [_vm._v(" " + _vm._s(_vm.betaBadgeText) + " ")]) : _vm._e(), item.new ? _c(_setup.XBadge, { class: badgeClass, attrs: { "icon": "sparkles", "color": "brand-primary", "size": "sm" } }, [_vm._v(" " + _vm._s(_vm.newBadgeText) + " ")]) : _vm._e()];
          } }], null, true) }, [item.header ? [_vm._v(" " + _vm._s(item.header) + " ")] : [_vm._t("default", function() {
            return [_c("span", { class: _vm.$style.listItemText, attrs: { "title": item.text }, domProps: { "innerHTML": _vm._s(item.highlighted || item.text) } })];
          })]], 2);
        });
      } }], null, true) })], 1)];
    }, proxy: true }], null, true) })];
  } }]) });
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XSelect = __component__.exports;
export {
  XSelect as default
};
